import { OrderDetailsProduct } from '@savgroup-front-common/types';
import useChooseProductCard from '@/view/app/hooks/useGetModelDetailByIdQuery';

const useResumeCardHeader = ({ product }: { product: OrderDetailsProduct }) => {
  const { modelDetail } = useChooseProductCard({ product });

  return { modelDetail };
};

export default useResumeCardHeader;
